import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { buildWaLink, GENERAL_MESSAGE, trackWhatsApp } from "@/lib/services";

export default function BigCTA() {
  return (
    <section data-testid="big-cta" className="py-16 md:py-20 bg-navy text-white">
      <div className="container-x text-center max-w-3xl mx-auto">
        <h2 className="text-[32px] md:text-[48px] font-extrabold leading-[1.1] text-white">
          Need care for a loved one today?
        </h2>
        <p className="mt-4 text-white/85 text-[17px]">We're nurse-led, local to Bangalore, and available around the clock. Message us or call — we'll help you figure out the next step.</p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <a data-testid="cta-wa" href={buildWaLink(GENERAL_MESSAGE)} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsApp("Big CTA WhatsApp")} className="btn-wa">
            <MessageCircle className="w-5 h-5" /> WhatsApp Us
          </a>
          <a data-testid="cta-call" href={`tel:${BRAND.phoneTel}`} className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-white text-navy font-semibold hover:bg-white/90">
            <Phone className="w-5 h-5" /> Call {BRAND.phone}
          </a>
        </div>
        <div className="mt-5 text-white/70 text-[14px]">Available 24/7 · UPI · Cash · Card · Bank transfer</div>
      </div>
    </section>
  );
}
